import React, { useEffect, useState } from "react";
import Navigation from "../../components/Navigation/Navigation";
import "./additionalInfo.css";
import image from "../../assets/image.png";
import { ClipLoader } from "react-spinners";
import { toast } from "react-hot-toast";
import { useParams } from "react-router";
import { CompactPicker } from "react-color";
import { request } from "../../utils/axios-utils";

const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
const validateUrl = (url) => {
  const urlRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
  return urlRegex.test(url);
};
const validateInstagram = (url) => {
  const instagramRegex =
    /^(https?:\/\/)?(www\.)?instagram\.com\/[a-zA-Z0-9_.]+\/?$/;
  return instagramRegex.test(url);
};
const validateFacebook = (url) => {
  const facebookRegex =
    /^(https?:\/\/)?(www\.)?facebook\.com\/[a-zA-Z0-9.]+\/?$/;
  return facebookRegex.test(url);
};
const validateTiktok = (url) => {
  const tiktokRegex = /^(https?:\/\/)?(www\.)?tiktok\.com\/@[a-zA-Z0-9_.]+\/?$/;
  return tiktokRegex.test(url);
};

const AdditionalInfo = () => {
  const { slug } = useParams();
  const [loading, setLoading] = useState("");
  const [additionalInfo, setAdditionalInfo] = useState({
    email: "",
    phone: "",
    location: "",
    wifiPassword: "",
    websiteUrl: "",
    instagramLink: "",
    facebookLink: "",
    tiktokLink: "",
    heroImage: null,
    mainColor: "",
  });

  const handleChangeData = (event) => {
    setAdditionalInfo((prevData) => ({
      ...prevData,
      [event.target.name]: event.target.value,
    }));
  };

  const handleColorChange = (color) => {
    setAdditionalInfo((prevData) => ({
      ...prevData,
      mainColor: color.hex,
    }));
  };

  const saveAdditionalInfo = async () => {
    if (additionalInfo.email && !validateEmail(additionalInfo.email)) {
      toast.error("Invalid email format.");
      return;
    }
    if (additionalInfo.websiteUrl && !validateUrl(additionalInfo.websiteUrl)) {
      toast.error("Invalid website URL.");
      return;
    }
    if (
      additionalInfo.instagramLink &&
      !validateInstagram(additionalInfo.instagramLink)
    ) {
      toast.error("Invalid Instagram profile URL.");
      return;
    }
    if (
      additionalInfo.facebookLink &&
      !validateFacebook(additionalInfo.facebookLink)
    ) {
      toast.error("Invalid Facebook profile URL.");
      return;
    }
    if (
      additionalInfo.tiktokLink &&
      !validateTiktok(additionalInfo.tiktokLink)
    ) {
      toast.error("Invalid TikTok profile URL,");
      return;
    }

    try {
      setLoading("saving");
      const formData = new FormData();
      formData.append("image", additionalInfo.heroImage);
      formData.append("additionalInfo", JSON.stringify(additionalInfo));
      formData.append("slug", JSON.stringify(slug));

      const response = await request({
        url: "/member/save-additional-info",
        method: "POST",
        data: formData,
      });

      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setLoading("");
    }
  };

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading("data");
        const response = await request({
          url: "/member/get-additional-info",
          method: "POST",
          data: { slug },
        });

        setAdditionalInfo(response.data.additionalInfo);
      } catch (error) {
        toast.error(error.response.data.message);
      } finally {
        setLoading("");
      }
    };

    getData();
  }, []);

  return (
    <Navigation isLoading={loading === "data"}>
      <h1 className="page-content-h">Additional Info</h1>
      <p className="page-content-p">
        Add your contact info, socials, hero image and more...
      </p>

      <div className="languages-container">
        <label htmlFor="email" className="additional-info-label">
          Email address
        </label>
        <input
          value={additionalInfo.email}
          onChange={handleChangeData}
          name="email"
          id="email"
          placeholder="Email address"
          className="classic-input mb-16"
          maxLength={30}
        />

        <label htmlFor="phone" className="additional-info-label">
          Phone number
        </label>
        <input
          value={additionalInfo.phone}
          onChange={handleChangeData}
          name="phone"
          id="phone"
          placeholder="Phone number"
          className="classic-input mb-16"
          maxLength={30}
        />

        <label htmlFor="location" className="additional-info-label">
          Location
        </label>
        <input
          value={additionalInfo.location}
          onChange={handleChangeData}
          name="location"
          id="location"
          placeholder="Location"
          className="classic-input mb-16"
          maxLength={50}
        />

        <label htmlFor="password" className="additional-info-label">
          WIFI Password
        </label>
        <input
          value={additionalInfo.wifiPassword}
          onChange={handleChangeData}
          name="wifiPassword"
          id="password"
          placeholder="WIFI Password"
          className="classic-input mb-16"
          maxLength={30}
        />

        <label htmlFor="websiteUrl" className="additional-info-label">
          Website Url
        </label>
        <input
          value={additionalInfo.websiteUrl}
          onChange={handleChangeData}
          name="websiteUrl"
          id="websiteUrl"
          placeholder="Website Url"
          className="classic-input mb-16"
          maxLength={100}
        />

        <label htmlFor="instagramLink" className="additional-info-label">
          Instagram Link
        </label>
        <input
          value={additionalInfo.instagramLink}
          onChange={handleChangeData}
          name="instagramLink"
          id="instagramLink"
          placeholder="Instagram Link"
          className="classic-input mb-16"
          maxLength={100}
        />

        <label htmlFor="facebookLink" className="additional-info-label">
          Facebook Link
        </label>
        <input
          value={additionalInfo.facebookLink}
          onChange={handleChangeData}
          name="facebookLink"
          id="facebookLink"
          placeholder="Facebook Link"
          className="classic-input mb-16"
          maxLength={100}
        />

        <label htmlFor="tiktokLink" className="additional-info-label">
          Tiktok Link
        </label>
        <input
          value={additionalInfo.tiktokLink}
          onChange={handleChangeData}
          name="tiktokLink"
          id="tiktokLink"
          placeholder="Tiktok Link"
          className="classic-input mb-16"
          maxLength={100}
        />

        <label htmlFor="tiktokLink" className="additional-info-label">
          Hero Image
        </label>
        <div className="image-input-div">
          <div
            className={
              additionalInfo.heroImage
                ? "image-input border-none"
                : "image-input"
            }
          >
            {additionalInfo.heroImage ? (
              <>
                <img
                  className="image-output"
                  src={
                    additionalInfo.heroImage.url
                      ? additionalInfo.heroImage.url
                      : URL.createObjectURL(additionalInfo.heroImage)
                  }
                />
                <input
                  onChange={(event) => {
                    const file = event.target.files[0];
                    const reader = new FileReader();
                    reader.onload = (event) => {
                      setAdditionalInfo((prevState) => ({
                        ...prevState,
                        heroImage: file,
                      }));
                    };
                    reader.readAsDataURL(file);
                  }}
                  type="file"
                  accept="image/*"
                />
              </>
            ) : (
              <>
                <img className="image-placeholder" src={image} />

                <input
                  onChange={(event) => {
                    const file = event.target.files[0];
                    const reader = new FileReader();
                    reader.onload = (event) => {
                      setAdditionalInfo((prevState) => ({
                        ...prevState,
                        heroImage: file,
                      }));
                    };
                    reader.readAsDataURL(file);
                  }}
                  type="file"
                  accept="image/*"
                />
              </>
            )}
          </div>
        </div>

        <label htmlFor="tiktokLink" className="additional-info-label">
          Main Menu Color
        </label>
        <CompactPicker
          color={additionalInfo.mainColor}
          onChangeComplete={handleColorChange}
        />

        <div onClick={saveAdditionalInfo} className="additional-info-btn">
          {loading === "saving" ? (
            <ClipLoader size={20} color={"#fff"} />
          ) : (
            "Save Additional Info"
          )}
        </div>
      </div>
    </Navigation>
  );
};

export default AdditionalInfo;
